/**
 * Lists human agents in the active workspace for routing/capacity UI.
 * Uses tenant-user-dashboard (Kong + introspect); requires Settings page RBAC.
 */

import { tenantApiFetch, tenantDashboardPath } from "@/lib/tenantApi";

/**
 * @returns {Promise<{ agents: Array<{ id: number, name: string, email?: string }> }>}
 */
export async function fetchRoutingAgentCandidates() {
  return tenantApiFetch(tenantDashboardPath("/settings/routing-agent-candidates"));
}
